// eslint-disable-next-line no-unused-vars
import React from "react";

import { EmbeddedPage } from "../../../layouts";
import VehicleSingleRegistryUploadWidget from "../widgets/VehicleSingleRegistryUploadWidget";

export class VehicleSingleRegistryUploadWidgetPage extends React.Component {
  render() {
    return (
      <EmbeddedPage>
        <VehicleSingleRegistryUploadWidget />
      </EmbeddedPage>
    );
  }
}

export default VehicleSingleRegistryUploadWidgetPage;
